import { axiosInfraInstance } from '.';

export const GetVersions = async (payload) => {
  const url = `/infrastructureManagement/v1/deviceManagement/internal/v1/device/pdSwVers`;
  return await axiosInfraInstance({ method: 'Post', url: url, data: payload });
};

export const UpdateVersion = async (payload, orgId) => {
  const url = `/infrastructureManagement/v1/deviceManagement/internal/v1/organisations/${orgId}/device/update`;
  return await axiosInfraInstance({ method: 'Post', url: url, data: payload });
};

export const GetUpdateDetails = async (payload, orgId) => {
  const url = `/infrastructureManagement/v1/deviceManagement/internal/v1/organisations/${orgId}/device/update/details`;
  return await axiosInfraInstance({ method: 'Post', url: url, data: payload });
};

export const CancelFirmwareUpdate = async (payload, orgId) => {
  const url = `/infrastructureManagement/v1/deviceManagement/internal/v1/organisations/${orgId}/device/update/cancel`;
  return await axiosInfraInstance({ method: 'Post', url: url, data: payload });
};
